import styled from 'styled-components';
import { Empty } from '../../../index';

export const StyledEmpty = styled(Empty)`
  width: 100%;
  padding: 20px 0;
  background: #fff;
`;

export const ButtonWrapper = styled.div`
  padding-top: 20px;
`;
